"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrganizationTypes = void 0;
var OrganizationTypes;
exports.OrganizationTypes = OrganizationTypes;
(function (OrganizationTypes) {
  OrganizationTypes["Bank"] = "bank";
  OrganizationTypes["ForeignBank"] = "foreignBank";
  OrganizationTypes["Insurance"] = "insurance";
  OrganizationTypes["MFO"] = "mfo";
  OrganizationTypes["Educational"] = "educationalOrganization";
  OrganizationTypes["Broker"] = "broker";
  OrganizationTypes["Investment"] = "investment";
  OrganizationTypes["MortgageAgent"] = "mortgageAgent";
  OrganizationTypes["NonbankingOrganization"] = "nonbankingOrganization";
  OrganizationTypes["Other"] = "other";
  OrganizationTypes["Appraiser"] = "appraiser";
  OrganizationTypes["PensionFund"] = "pensionFund";
})(OrganizationTypes || (exports.OrganizationTypes = OrganizationTypes = {}));